import { useQuery } from "@tanstack/react-query";
import { getVacationHomes } from "../api/reservationApi";
import { reservationKeys } from "../api/reservationKeys";

export const useVacationHomes = () =>
  useQuery({
    queryKey: reservationKeys.vacationHomes(),
    queryFn: getVacationHomes,
  });
